// The mobile site is navy: dark blue (#092647) takes the place of Pretor blue (#0065a4)
// in buttons, amounts, links and tabs. Mobile widths only; desktop keeps Pretor blue.
//
// The site's blues are hard-coded in hundreds of rules (the LESS variable, and near-identical
// literals such as #0064a2 in older files), so rather than override selectors by hand this
// edits the matching declarations of the loaded stylesheets in place, and puts the originals
// back when the screen grows past mobile width. In place, so the cascade (which rule wins)
// is exactly as authored. Applied once, from app.js.

const MOBILE = '(max-width: 991px)';
// Where the choice used to be kept, while navy was one of several previews
const OLD_PREVIEW_KEY = 'mobileThemePreview';

const BLUE = [0, 101, 164];
const NAVY = [9, 38, 71];

const COLOUR_PROPERTIES = [
    'color', 'background-color', 'background-image', 'border-top-color', 'border-right-color',
    'border-bottom-color', 'border-left-color', 'outline-color', 'box-shadow', 'fill', 'stroke'
];

const COLOUR_PATTERN = /#([0-9a-f]{6})\b|#([0-9a-f]{3})\b|rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+)\s*)?\)/gi;

let applied = [];        // [{ style, property, value, priority }] to put back
let mediaQuery = null;

const isNear = (rgb, target) =>
    Math.abs(rgb[0] - target[0]) + Math.abs(rgb[1] - target[1]) + Math.abs(rgb[2] - target[2]) <= 6;

const parse = (hex6, hex3, r, g, b) => {
    if (hex6) {
        return [0, 2, 4].map(i => parseInt(hex6.substr(i, 2), 16));
    }
    if (hex3) {
        return [0, 1, 2].map(i => parseInt(hex3[i] + hex3[i], 16));
    }
    return [+r, +g, +b];
};

// The value with Pretor blue made navy, or null when it does not use the colour
const toNavy = (value) => {
    let changed = false;
    const result = value.replace(COLOUR_PATTERN, (match, hex6, hex3, r, g, b, alpha) => {
        if (!isNear(parse(hex6, hex3, r, g, b), BLUE)) {
            return match;
        }
        changed = true;
        return alpha !== undefined ? `rgba(${NAVY.join(', ')}, ${alpha})` : `rgb(${NAVY.join(', ')})`;
    });
    return changed ? result : null;
};

const eachStyle = (rules, visit) => {
    Array.prototype.forEach.call(rules || [], rule => {
        if (rule.cssRules) {
            eachStyle(rule.cssRules, visit);
        }
        if (rule.style) {
            visit(rule.style);
        }
    });
};

const restore = () => {
    applied.forEach(({ style, property, value, priority }) => style.setProperty(property, value, priority));
    applied = [];
};

const swapAll = () => {
    Array.prototype.forEach.call(document.styleSheets, sheet => {
        let rules;
        try {
            rules = sheet.cssRules;
        } catch (e) {
            // A cross-origin stylesheet (the CDN datepicker): not readable, and not ours
            return;
        }
        eachStyle(rules, style => {
            COLOUR_PROPERTIES.forEach(property => {
                const value = style.getPropertyValue(property);
                const swapped = value && toNavy(value);
                if (swapped) {
                    const priority = style.getPropertyPriority(property);
                    applied.push({ style, property, value, priority });
                    style.setProperty(property, swapped, priority);
                }
            });
        });
    });
};

// Navy while the screen is mobile width, Pretor blue when it is not
const sync = () => {
    restore();
    if (mediaQuery && mediaQuery.matches) {
        swapAll();
    }
};

export function applyMobileNavyTheme() {
    if (!mediaQuery) {
        mediaQuery = window.matchMedia(MOBILE);
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', sync);
        } else {
            mediaQuery.addListener(sync);
        }
    }
    sync();

    try {
        window.localStorage.removeItem(OLD_PREVIEW_KEY);
    } catch (e) {
        // Storage blocked: nothing to tidy
    }
}
